import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSEO } from "../lib/seo";
import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { FAQAccordion } from "../components/FAQAccordion";
import { CTABand } from "../components/CTABand";
import { GENERAL_FAQS } from "../lib/faqs";
import { SERVICES } from "../lib/services";

const FAQPage = () => {
  useSEO(
    "FAQs | Kay's Carpet Cleaning Gold Coast",
    "Answers to common questions about professional carpet, couch, rug, mattress, tile and commercial cleaning on the Gold Coast. Call Kay's Carpet Cleaning on 0450 311 907."
  );

  return (
    <div data-testid="faq-page">
      <PageHero
        overline="FAQs"
        title="Frequently Asked"
        titleItalic="Questions"
        text="Straight answers to the questions Gold Coast customers ask us most. For service-specific questions, each service page has its own detailed FAQ section."
        testId="faq-hero"
      />

      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-16">
        <Reveal>
          <FAQAccordion items={GENERAL_FAQS} testIdPrefix="general-faq" />
        </Reveal>

        <Reveal className="mt-16">
          <h2 className="font-display font-medium text-2xl sm:text-3xl tracking-tight text-brand-ink mb-6">
            Service-specific questions
          </h2>
          <div className="grid sm:grid-cols-2 gap-3">
            {SERVICES.map((s) => (
              <Link
                key={s.slug}
                to={`/${s.slug}`}
                data-testid={`faq-service-link-${s.slug}`}
                className="group flex items-center justify-between gap-4 bg-white border border-brand-line/60 rounded-xl px-5 py-4 hover:border-brand transition-colors duration-300"
              >
                <span className="text-sm font-semibold text-brand-ink group-hover:text-brand transition-colors duration-300">{s.menu} FAQs</span>
                <ArrowRight size={16} className="text-brand-muted group-hover:text-brand group-hover:translate-x-1 transition-[color,transform] duration-300" />
              </Link>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 sm:pb-32">
        <CTABand id="faq-final" heading="Ready to Talk About Your Cleaning?" text="Send us the details of your job and we'll provide an estimate based on your requirements." primaryLabel="Get My Estimate" />
      </div>
    </div>
  );
};

export default FAQPage;
